<template>
    <div>

    </div>
</template>

<script>
    export default {
        name: "page1",
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {

        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/pc/page1.vue